import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { PageContainer } from '../components/layout/PageContainer';
import { Logo } from '../components/common/Logo';

export function TermsOfServicePage() {
  return (
    <PageContainer className="px-4 py-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-2xl mx-auto"
      >
        <div className="text-center mb-8">
          <Logo size="lg" className="mb-2" />
        </div>

        <div className="glass-card rounded-3xl p-6 sm:p-8">
          <Link to="/login" className="inline-flex items-center gap-1 text-turquoise text-sm mb-6 hover:underline">
            <ArrowLeft className="w-4 h-4" />
            Voltar
          </Link>

          <h1 className="text-2xl font-bold text-white mb-6">Termos de Uso</h1>

          <div className="space-y-6 text-white/70 text-sm leading-relaxed">
            <p>Ultima atualizacao: 12 de marco de 2026</p>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">1. Aceitacao dos termos</h2>
              <p>Ao acessar e utilizar o BT Vision ("Servico"), voce concorda com estes Termos de Uso. Se voce nao concordar, nao utilize o Servico.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">2. Descricao do servico</h2>
              <p>O BT Vision e uma plataforma para organizar rankings e torneios de beach tennis: criacao de rankings, sorteio de duplas por rodada, registro de placares, classificacao automatica e estatisticas do jogador. Opcionalmente, o organizador pode cobrar inscricao via PIX dos participantes.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">3. Conta e acesso</h2>
              <ul className="list-disc list-inside space-y-1">
                <li>Voce e responsavel por manter a seguranca da sua conta.</li>
                <li>Voce deve fornecer informacoes verdadeiras ao se cadastrar.</li>
                <li>Cada pessoa deve ter apenas uma conta.</li>
                <li>Voce deve ter pelo menos 13 anos para utilizar o Servico.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">4. Inscricoes pagas e taxa de servico</h2>
              <ul className="list-disc list-inside space-y-1">
                <li>O uso do BT Vision e gratuito para criar rankings, participar deles e acessar suas estatisticas.</li>
                <li>O organizador pode habilitar cobranca de inscricao em um ranking. As cobrancas sao emitidas via PIX pelo Asaas, na conta do proprio organizador, que e o responsavel pelo valor, pelo reembolso e pela relacao com os participantes.</li>
                <li>Sobre cada inscricao paga, o BT Vision retem uma taxa de servico, informada na tela de configuracao de pagamento do ranking e na tela de conexao do Asaas antes de qualquer cobranca ser gerada. A taxa e repassada automaticamente pelo Asaas na liquidacao.</li>
                <li>A taxa vigente e a que estiver configurada no momento em que a cobranca e gerada; alteracoes valem apenas para cobrancas futuras, inclusive renovacoes de temporada.</li>
                <li>Em caso de estorno da inscricao, o Asaas reverte tambem a parcela da taxa de servico.</li>
                <li>O BT Vision nao processa nem retem os valores das inscricoes: eles vao direto para a conta Asaas do organizador.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">5. Uso aceitavel</h2>
              <p>Voce concorda em nao:</p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Usar o Servico para fins ilegais ou nao autorizados.</li>
                <li>Tentar acessar dados de outros usuarios sem autorizacao.</li>
                <li>Realizar engenharia reversa ou tentar extrair o codigo-fonte do Servico.</li>
                <li>Sobrecarregar intencionalmente a infraestrutura do Servico.</li>
                <li>Usar bots ou automacao para acessar o Servico sem autorizacao.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">6. Dados e conteudo</h2>
              <ul className="list-disc list-inside space-y-1">
                <li>Os placares e a classificacao sao registrados pelos proprios participantes e organizadores; o BT Vision nao verifica sua exatidao.</li>
                <li>Estatisticas sao geradas automaticamente e tem carater informativo.</li>
                <li>A importacao de perfil da LetzPlay e opcional e traz apenas nome de exibicao e foto, a partir de dados publicos. O BT Vision nao e afiliado a LetzPlay.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">7. Limitacao de responsabilidade</h2>
              <p>O Servico e fornecido "como esta", sem garantias de qualquer tipo. Nao nos responsabilizamos por danos decorrentes do uso do Servico, incluindo dados imprecisos, indisponibilidade temporaria ou perda de dados.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">8. Cancelamento e encerramento</h2>
              <ul className="list-disc list-inside space-y-1">
                <li>Voce pode excluir sua conta a qualquer momento nas configuracoes.</li>
                <li>Reservamo-nos o direito de suspender contas que violem estes termos.</li>
                <li>Ao excluir sua conta, seus dados serao removidos conforme nossa Politica de Privacidade.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">9. Alteracoes nos termos</h2>
              <p>Podemos atualizar estes termos periodicamente. Alteracoes significativas serao comunicadas por email. O uso continuado do Servico apos alteracoes constitui aceitacao dos novos termos.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-white mb-2">10. Contato</h2>
              <p>Para duvidas, entre em contato pelo email: <a href="mailto:contato@retrospectivabeach.online" className="text-turquoise hover:underline">contato@retrospectivabeach.online</a></p>
            </section>
          </div>
        </div>

        <p className="mt-8 text-center text-sm text-white/30">
          &copy; 2026 BT Vision &bull; btvision.app
        </p>
      </motion.div>
    </PageContainer>
  );
}
